import { Marker } from "@/types/defs/pitchCorrection/marker";
import { PitchStateSnapshot } from "@/types/defs/pitchCorrection/pitchStateSnapshot";
import { Undoable } from "@/types/defs/pitchCorrection/undoable";

// Both stacks only ever hold pre-edit snapshots, so a step must capture the state it is about to displace and push it onto the opposite stack — otherwise the step can't be reversed. The captured entry mirrors the restored entry's kind: restoring pitch state displaces pitch state, restoring markers displaces markers. Arrays are copied because the editor keeps mutating the live ones on subsequent edits.
export const captureCurrentUndoable = ({
  restored,
  currentPitchState,
  currentCircles,
  now,
}: {
  restored: Undoable;
  currentPitchState: PitchStateSnapshot;
  currentCircles: Marker[];
  now: Date;
}): Undoable => ({
  time: now,
  source: "history",
  value:
    "pitches" in restored.value ?
      { ...currentPitchState, pitches: currentPitchState.pitches.slice() }
    : currentCircles.slice(),
});
